/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Names for tenant
 */
export interface TenantNames {
  displayName: string;
  shortName: string;
  legalName: string;
}
